export function IllustrationComplexiteMetier({ className }: { className?: string }) {
  return (
    <img
      className={className}
      src="/images/atelier-reparation.webp"
      alt="Réparation d'un smartphone en atelier"
      loading="lazy"
      style={{ borderRadius: 'var(--radius-md)', objectFit: 'cover' }}
    />
  );
}
